import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import Axios from "axios";
import utils from "../utils";
import './assets/glable.css'
import qs from "qs";
import Clipboard from "clipboard/dist/clipboard";

Vue.use(Vant);
Vue.prototype.$qs = qs;
Vue.prototype.$axios = Axios;
Vue.prototype.Clipboard=Clipboard;
// step3：使每次请求都会带一个 /api 前缀
// Axios.defaults.baseURL = '/api';
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
